import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import Project, { ProjectType } from './project';

import styles from './projects.module.scss';

const Projects = ({ items }) => (
  <div styleName="container">
    <div className="grid-container">
      <div className="grid-x align-center">
        <div className="cell small-12 medium-10">
          <div className="grid-x grid-margin-x align-stretch">
            {items &&
              items.map(item => (
                <div key={item.name} className="cell large-4 medium-6 small-12" styleName="cell">
                  <Project style={{ height: '100%' }} {...item} />
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);
Projects.propTypes = {
  items: PropTypes.arrayOf(ProjectType),
};
Projects.defaultProps = {
  items: [],
};

export const ProjectsType = PropTypes.shape(Projects.propTypes);

export default CSSModules(Projects, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/portfolio/projects.jsx